import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Flex, Div, TertiarySmall } from "@base-ui";
import { translatePeriod } from "utils/periods";
import { allGenderTypes } from "utils/genders";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function GraphDescription(_ref) {
  var genders = _ref.genders,
    age = _ref.age,
    periodType = _ref.periodType,
    informationSource = _ref.informationSource;
  var translatedGenders = genders.map(function (gender) {
    return allGenderTypes[gender];
  }).join(" + ");
  var metaStyles = {
    fontFamily: "roboto-regular"
  };
  return /*#__PURE__*/_jsxs(Flex.Row, {
    className: "add-pre-png",
    breakpoint: "sm",
    display: "none",
    children: [/*#__PURE__*/_jsxs(Div, {
      mb: "10px",
      width: "50%",
      children: [/*#__PURE__*/_jsx(TertiarySmall, {
        m: "0 0 -5px 0",
        children: "Urval"
      }), /*#__PURE__*/_jsx(TertiarySmall, _objectSpread(_objectSpread({
        display: "inline-block",
        width: "100%",
        mr: "5px"
      }, metaStyles), {}, {
        children: "K\xF6n: ".concat(translatedGenders, ", \xC5lder: ").concat(age, ", Period: ").concat(translatePeriod(periodType))
      }))]
    }), informationSource && /*#__PURE__*/_jsxs(Div, {
      width: "50%",
      children: [/*#__PURE__*/_jsx(TertiarySmall, {
        m: "0 0 -5px 0",
        children: "K\xE4lla:"
      }), /*#__PURE__*/_jsx(TertiarySmall, {
        style: metaStyles,
        children: informationSource
      })]
    })]
  });
}